// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3115":"a437714b","4071":"bbf44393","4242":"e785b264","5431":"40d945be","6858":"799e91e8","8110":"a437714b","9307":"568aa915","9853":"41dd65a2","9978":"dc32d884"}[chunkId] + ".chunk.css";
};